<template>
  <div>
    <h4>Add Week</h4>
    <form @submit.prevent="submit" v-if="! loading">
      <div class="form-group">
        <label>Week Title</label>
        <input
          type="text"
          placeholder="Week Title"
          v-model="week.title"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>Sort Order</label>
        <input
          type="text"
          placeholder="Sort Order"
          v-model="week.sort"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>Cost in USD</label>
        <input
          type="text"
          placeholder="Cost in USD"
          v-model="week.cost"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>About this week</label>
        <editor
          api-key="no-api-key"
          v-model="week.about"
          :init="{
            height: 500,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
          }"
        />
      </div>
      <div class="form-group">
        <button class="btn btn-primary">Save</button>
      </div>
    </form>
    <loading v-if="loading" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      week: {},
      loading: false
    };
  },

  methods: {
    submit() {
      this.loading = true

      this.$axios
        .post(`/api/v1/admin/academy/${this.$route.params.course_id}/weeks`, this.week)
        .then((response) => {
          this.loading = false

          this.$router.push({
            name: 'admin.academy.weeks.show',
            params: { week_id: response.data.id }
          });
        });
    },
  },
};
</script>